import slugify from 'slugify';

export const toSlug = (value = '', locale = 'en') =>
    slugify(value, {
        lower: true,
        strict: true,
        trim: true,
        locale,
    });
